import { render } from "./sectionFooter.vue?vue&type=template&id=00f12984&scoped=true"
import script from "./sectionFooter.vue?vue&type=script&lang=js"
export * from "./sectionFooter.vue?vue&type=script&lang=js"

import "./sectionFooter.vue?vue&type=style&index=0&id=00f12984&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-00f12984"]])

export default __exports__